<template>
    <div id="Settings_Header">
        <div class="HeaderRow">
            <div id="FactoryFilterContainer">
                <div class="FilterTitle">工場</div>
                <div class="FilterElement RoundShadowElement">
                    <GenericMultiDropdown id="FactoryFilter" ref="FactoryFilter" :-allow-multiple=true :-close-on-select=false :InputPlaceholder="'工場を選択'" :options="FactoryOptions" label="Test" :OnChange="OnFactoryChange" />
                </div>
            </div>
            <div style="place-content: end; display: grid; padding-bottom: 9px; margin-left: 20px;">
                <div class="Button ButtonNormal NoSelect"
                     @click="SendSyncMoldRequest">
                    同期
                </div>
                <!-- ToDo: Show last sync date here -->
            </div>
            <div id="SearchContainer">
                <TextSearch :Label="'サーチ'" :Placeholder="'金型名'" :OnChange="OnSearchChange" :OnTyping="OnSearchChange" />
            </div>
        </div>
        <div class="HeaderRow">
            <div class="FilterContainer" style="margin-top: -25px; margin-left: 25px;">
                <div class="FilterTitle">年</div>
                <div>
                    <VueSlider v-model="FilterYear" :min="MinFilterYear" :max="MaxFilterYear" :maxRange="MaxFilterYear" marks @drag-end="OnFilterYearChange" />
                </div>
            </div>
            <div class="FilterContainer" style="margin-top: -25px; margin-left: 45px;" v-if="FilterYear[0] === FilterYear[1]">
                <div class="FilterTitle">月</div>
                <div>
                    <VueSlider v-model="FilterMonth" :min="1" :max="12" marks @drag-end="OnFilterMonthChange" />
                </div>
            </div>
        </div>
        <div class="HeaderRow">
            <div class="MoldInfo">
                支払い中
                <div>{{ this.PayingMolds }}</div>
            </div>
            <div class="MoldInfo PayingFromNextMonth">
                来月から支払い
                <div :title="`来月は金型${this.PayingFromNextMonth - this.PayingMolds}個の支払いが始める`">
                    {{ this.PayingFromNextMonth }}
                </div>
            </div>
            <div class="MoldInfo FinishedThisMonth">
                今月完了
                <div>
                    {{ this.FinishedThisMonth }}
                </div>
            </div>
            <div class="MoldInfo FinishedNextMonth">
                来月完了
                <div>
                    {{ this.FinishedNextMonth }}
                </div>
            </div>
            <div class="MoldInfoAddition">
                <div>PayingThisMonth: {{ PayingThisMonth }}</div>
                <div>PayingNextMonth: {{ PayingNextMonth }}</div>
                <div>PayingThisYear: {{ PayingThisYear }}</div>
            </div>
        </div>
    </div>
    <div id="DataContainer">
        <div id="Sorting">
            <div style="margin-left: 5px;"></div>
            <SortingButton :style="{'max-width': entry.width, flex: entry.Label === '金型名' ? 1.0 : 0.5}" v-for="(entry, index) in SortingOptions" :key="index" :IsDesc="IsSortingDesc" :Label="entry.Label" :IsSorting="CurrentSortType === index" :-sorting-type="index" :-on-click="OnSorting" />
        </div>
        <div id="MoldList">
            <div class="MoldEntryContainer" v-for="entry in Molds" :key="entry">
                <MoldEntry v-if="IsFactoryFiltered(entry.factory) && IsNameFiltered(entry.name)" :MoldData="entry" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import GenericMultiDropdown from '@/components/GenericMultiDropdown.vue';
import MoldEntry from '@/components/MoldEntry.vue';
import VueSlider from 'vue-3-slider-component';
import { ShowLoading } from '@/utils/FullScreenLoading';
import TextSearch from '@/components/TextSearch.vue';
import SortingButton from '@/components/SortingButton.vue';

export default {
    components:{
        GenericMultiDropdown,
        VueSlider,
        MoldEntry,
        TextSearch,
        SortingButton,
    },
    mounted()
    {
        // For this page we know that the data we want, depreciation of molds,
        // is being separated into 12 month installments.
        // We always want to see at a glance which molds are currently being depreciated.
        // That means, unless we have currently December, we want to show by default
        // molds from the previous year as well as they may fall into the current year
        const now = new Date();
        this.FilterYear[0] = now.getMonth() === 11 ? now.getFullYear() : now.getFullYear() - 1;
        this.FilterYear[1] = now.getFullYear();

        this.GetMoldData();
    },
    methods:{
        async GetMoldData()
        {
            this.Molds = [];

            ShowLoading(true, 'ローディング中');

            const startDate = moment();
            startDate.year(this.FilterYear[0]);
            startDate.month(this.FilterYear[0] === this.FilterYear[1] ? this.FilterMonth[0] : 1);
            startDate.date(0);
            startDate.hour(0);
            startDate.minute(0);
            startDate.second(0);

            const endDate = moment();
            endDate.year(this.FilterYear[1]);
            endDate.month(this.FilterYear[0] === this.FilterYear[1] ? this.FilterMonth[1] : 12);
            endDate.date(0);
            endDate.hour(0);
            endDate.minute(0);
            endDate.second(0);

            let data = {
                SessionToken: this.$GetToken(),
                StartDate: this.$FormatDateForServer(startDate),
                EndDate: this.$FormatDateForServer(endDate),
            };

            const moldData = await axios.post(process.env.VUE_APP_BACKEND_URL + 'molds', data)
            .then(result => {
                ShowLoading(false);
                return result.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Mold data request error', error);
                return null;
            });

            console.log('Mold data result', moldData);

            const minDate = moldData.dateRange.length > 0 ? new Date(moldData.dateRange[0].min_date) : new Date();
            const maxDate = moldData.dateRange.length > 0 ? new Date(moldData.dateRange[0].max_date) : new Date();

            this.MinFilterYear = minDate.getFullYear();
            this.MaxFilterYear = maxDate.getFullYear();

            this.FactoryOptions = [];
            for (let i = 0; i < moldData.factories.length; i++)
            {
                this.FactoryOptions.push({ label: moldData.factories[i].name, value: moldData.factories[i].id });
            }

            this.Molds = moldData.molds;
            
            this.PayingMolds = moldData.currentlyPayingCount;
            this.PayingFromNextMonth = moldData.nextMonthPayingCount;
            this.FinishedNextMonth = moldData.finishedNextMonth;
            this.FinishedThisMonth = moldData.finishedThisMonth;
            this.PayingThisYear = this.$FormatCurrency(moldData.amountThisYear);
            this.PayingThisMonth = this.$FormatCurrency(moldData.amountThisMonth);
            this.PayingNextMonth = this.$FormatCurrency(moldData.amountNextMonth);

            const now = new Date();
            
            for (let i = 0; i < this.Molds.length; i++)
            {
                const m = this.Molds[i];

                const paymentStart = new Date(m.import_at);
                // Just a day that exists in every month
                paymentStart.setDate(2);
                const paymentEnd = new Date(paymentStart);
                paymentEnd.setMonth(paymentEnd.getMonth() + 12);

                if (m.paymentCount + 1 === 12)
                {
                    m.FinishedNextMonth = true;
                }

                const monthDiff = this.GetDateDiffInMonth(now, paymentStart);
                // If this month is the last payment
                if (monthDiff === 11)
                {
                    m.FinishedThisMonth = true;
                }
                // If payment starts from next month
                else if (monthDiff === -1)
                {
                    m.PayingFromNextMonth = true;
                }
            }
        },
        GetDateDiffInMonth(now, paymentStart)
        {
            return (now.getFullYear() - paymentStart.getFullYear()) * 12 + (now.getMonth() - paymentStart.getMonth());
        },
        OnFactoryChange(newFactoryFilter)
        {
            this.SelectedFactories = newFactoryFilter;
        },
        OnFilterYearChange()
        {
            this.GetMoldData();
        },
        OnFilterMonthChange()
        {
            this.GetMoldData();
        },
        OnSorting(sortingType)
        {
            if (this.CurrentSortType !== sortingType)
            {
                this.IsSortingDesc = true;
            }
            else
            {
                this.IsSortingDesc = !this.IsSortingDesc;
            }

            this.CurrentSortType = sortingType;
            this.SortData();
        },
        async SortData()
        {
            const sortFunc = this.IsSortingDesc ? this.SortingOptions[this.CurrentSortType].Desc : this.SortingOptions[this.CurrentSortType].Asc;
            this.Molds.sort(sortFunc);
            console.log('Molds sorted', this.Molds);
        },
        IsFactoryFiltered(factory)
        {
            if (this.SelectedFactories === null ||
                this.SelectedFactories === undefined ||
                this.SelectedFactories.length === 0)
            {
                return true;
            }

            for (let i = 0; i < this.SelectedFactories.length; i++)
            {
                if (this.SelectedFactories[i].label === factory)
                {
                    return true;
                }
            }

            return false;
        },
        IsNameFiltered(moldName)
        {
            if (this.SearchString === '' ||
                this.SearchString === null ||
                this.SearchString === undefined)
            {
                return true;
            }

            return moldName.toLowerCase().includes(this.SearchString.toLowerCase());          
        },
        OnSearchChange(newSearch)
        {
            this.SearchString = newSearch;
        },
        async SendSyncMoldRequest()
        {
            let data = {
                SessionToken: this.$GetToken(),
            };

            const syncResponse = await axios.post(process.env.VUE_APP_BACKEND_URL + 'molds/sync', data)
            .then(result => {
                return result.status;
            })
            .catch(error => {
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Mold data request error', error);
                return null;
            });

            console.log('Sync response', syncResponse);
            if (syncResponse === 200)
            {
                this.GetMoldData();
            }
        },
        PaymentStatusScore(paymentStatus)
        {
            switch (paymentStatus)
            {
                case 'cancelled': return -1;

                default:
                case 'pending': return 0;

                case 'in_progress': return 1;

                case 'paid': return 2;
            }
        }
    },
    data(){
        return{
            FilterYear: [new Date().getFullYear(), new Date().getFullYear()],
            FilterMonth: [1,12],
            MinFilterYear: new Date().getFullYear(),
            MaxFilterYear: new Date().getFullYear(),
            Molds: [],
            PayingThisMonth: 0,
            PayingNextMonth: 0,
            PayingThisYear: 0,
            PayingMolds: 0,
            PayingFromNextMonth: 0,
            FinishedNextMonth: 0,
            FinishedThisMonth: 0,
            FactoryOptions: [],
            SelectedFactories: [],
            SearchString: '',
            CurrentSortType: -1,
            IsSortingDesc: false,
            SortingOptions: [
                {
                    Label: '金型名',
                    Asc: function (a, b) { return a.name.localeCompare(b.name, 'ja'); },
                    Desc: function (a, b) { return b.name.localeCompare(a.name, 'ja'); },
                    width: '300px',
                },
                {
                    Label: '工場',
                    Asc: function (a, b) { return a.factory.localeCompare(b.factory, 'ja'); },
                    Desc: function (a, b) { return b.factory.localeCompare(a.factory, 'ja'); },
                },
                {
                    Label: '輸入予定月',
                    Asc: function(a,b){ return new Date(a.import_at)-new Date(b.import_at); },
                    Desc: function(a,b){ return new Date(b.import_at)-new Date(a.import_at); },
                },
                {
                    Label: '支払日',
                    Asc: function(a,b){ return new Date(a.payment_at)-new Date(b.payment_at); },
                    Desc: function(a,b){ return new Date(b.payment_at)-new Date(a.payment_at); },
                },
                {
                    Label: '金型代',
                    Asc: function(a,b){ return a.moldCostUSD-b.moldCostUSD; },
                    Desc: function(a,b){ return b.moldCostUSD-a.moldCostUSD; },
                },
                {
                    Label: 'Progress',
                    Asc: function(a,b){ return a.paymentCount-b.paymentCount; },
                    Desc: function(a,b){ return b.paymentCount-a.paymentCount; },
                },
                {
                    Label: '支払い状況',
                    Asc: (a,b) => this.PaymentStatusScore(a.payment_status)-this.PaymentStatusScore(b.payment_status),
                    Desc: (a,b) => this.PaymentStatusScore(b.payment_status)-this.PaymentStatusScore(a.payment_status),
                },
            ],
        }
    }
}
</script>

<style scoped>
#DataContainer
{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

#Sorting
{
    padding-right: 11px;
}

.SortingContainer
{
    place-content: center;
}

.SortingLabel
{
    font-weight: bold;
}

.SortingIndicatorContainer
{
    flex: 0 !important;
}

.MoldInfo
{
    margin-left: 15px;
    display: grid;
    place-content: center;
    text-align: center;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    width: 150px;

    div
    {
        font-weight: bold;
        margin-top: 10px;
    }
}

.MoldInfoAddition
{
    background-color: rgb(227, 227, 227);
    margin-left: 15px;
    display: grid;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    width: 250px;
    padding-left: 10px;
    font-size: 80%;
}

#MoldList
{
    overflow: auto;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
}

.MoldEntryContainer + .MoldEntryContainer
{
    margin-top: 10px;
}
</style>